import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb9a16c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }

export function render(_ctx, _cache) {
  const _component_p_inputtext = _resolveComponent("p-inputtext")
  const _component_p_button = _resolveComponent("p-button")

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_p_inputtext, {
      type: "text",
      placeholder: "Search",
      class: "rounded-input",
      style: {"color":"black"}
    }),
    _createVNode(_component_p_button, {
      icon: "pi pi-search",
      style: _normalizeStyle({'background-color' :  _ctx.app_base_data.second_theme_color,}),
      rounded: "",
      "aria-label": "Search"
    }, null, 8, ["style"])
  ]))
}